export default theme => ({
  options: {
    marginTop: 0,
    paddingLeft: 40,
  },
  checkboxLabel: {
    fontSize: 14,
  },
  resetLink: {
    cursor: "pointer",
    color: "blue",
  },
});
